var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "fence-map" }, [
    _c("div", {
      ref: "map",
      staticClass: "fence-map__canvas",
      style: { height: _vm.height },
    }),
    _c("div", { staticClass: "fence-map__legend caption" }, [
      _vm.company
        ? _c("span", [
            _c("span", {
              staticClass: "fence-map__dot fence-map__dot--company",
            }),
            _vm._v(" Empresa"),
          ])
        : _vm._e(),
      _vm.position
        ? _c("span", [
            _c("span", {
              staticClass: "fence-map__dot fence-map__dot--position",
            }),
            _vm._v(" Você"),
          ])
        : _vm._e(),
      _vm.company && _vm.radius
        ? _c("span", [
            _c("span", {
              staticClass: "fence-map__dot fence-map__dot--fence",
              class: `fence-map__dot--${_vm.status}`,
            }),
            _vm._v(" Raio de " + _vm._s(_vm.radius) + " m"),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }